import React, { useState, useEffect } from 'react';
import { useAuth } from '../../Common/Configurations/AuthContext';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import './ChangePassword.css';

const initialValues = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: ""
};

const ChangePasswordForm = () => {
    const { user } = useAuth();
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [apiError, setApiError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        let timer;
        if (successMessage) {
            timer = setTimeout(() => {
                setSuccessMessage('');
            }, 5000); // Message will disappear after 5 seconds
        }
        return () => clearTimeout(timer);
    }, [successMessage]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });

        // Clear the specific validation error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: undefined }));
        }

        // Clear API messages
        if (apiError) setApiError('');
        if (successMessage) setSuccessMessage('');
    };

    const validate = () => {
        let tempErrors = {};
        if (!values.oldPassword.trim()) {
            tempErrors.oldPassword = "Old password is required.";
        }
        if (!values.newPassword.trim()) {
            tempErrors.newPassword = "New password is required.";
        } else if (values.newPassword.length < 6) {
            tempErrors.newPassword = "Password must be at least 6 characters long.";
        }
        if (values.newPassword !== values.confirmNewPassword) {
            tempErrors.confirmNewPassword = "The new passwords do not match.";
        }

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setApiError('');
        setSuccessMessage('');

        if (validate()) {
            setIsLoading(true);
            try {
                const response = await apiService.post(config.CHANGEPASSWORD, {
                    userId: user.id,
                    oldPassword: values.oldPassword,
                    newPassword: values.newPassword,
                });

                setSuccessMessage("Password changed successfully!");
                setValues(initialValues);
                setErrors({});
            } catch (err) {
                setApiError("An error occurred.");
            } finally {
                setIsLoading(false);
            }
        }
    };

    const applyErrorClass = (field) => (errors[field] ? 'is-invalid' : '');

    return (
        <div className="main-content">
            <div className="change-password-wrapper">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-7 col-sm-9">
                            <div className="profile-card h-100">
                                <h4 className="card-title mb-4">Change Password</h4>
                                <form onSubmit={handleSubmit} noValidate>
                                    {apiError && <div className="alert alert-danger">{apiError}</div>}
                                    {successMessage && <div className="alert alert-success">{successMessage}</div>}

                                    <div className="mb-3">
                                        <label className="form-label">Old Password</label>
                                        <input
                                            type="password"
                                            name="oldPassword"
                                            value={values.oldPassword}
                                            onChange={handleInputChange}
                                            className={`form-control ${applyErrorClass('oldPassword')}`}
                                        />
                                        {errors.oldPassword && <div className="invalid-feedback">{errors.oldPassword}</div>}
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">New Password</label>
                                        <input
                                            type="password"
                                            name="newPassword"
                                            value={values.newPassword}
                                            onChange={handleInputChange}
                                            className={`form-control ${applyErrorClass('newPassword')}`}
                                        />
                                        {errors.newPassword && <div className="invalid-feedback">{errors.newPassword}</div>}
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Confirm New Password</label>
                                        <input
                                            type="password"
                                            name="confirmNewPassword"
                                            value={values.confirmNewPassword}
                                            onChange={handleInputChange}
                                            className={`form-control ${applyErrorClass('confirmNewPassword')}`}
                                        />
                                        {errors.confirmNewPassword && <div className="invalid-feedback">{errors.confirmNewPassword}</div>}
                                    </div>

                                    <div className="text-end mt-4">
                                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                            {isLoading ? 'Updating...' : 'Update Password'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePasswordForm;